import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class FramesetTabs extends ThemeComponent {
    @Ref() heading!: HTMLButtonElement[];
    @Ref() headingMobile!: HTMLButtonElement[];
    @Ref() content!: HTMLElement[];

    init() {

        // Add visibility click event listeners
        this.addVisibilityEventListeners();
    }

    addVisibilityEventListeners() {

        // Heading clicks
        if (this.heading) {
            for (const heading of this.heading) {
                this.$listen(heading, 'click', () => {

                    // Handle active classes
                    const headingTabId = heading.getAttribute('data-tab-id');
                    for (const otherHeading of this.heading) {
                        const otherHeadingTabId = otherHeading.getAttribute('data-tab-id');
                        if (otherHeadingTabId === headingTabId) {
                            otherHeading.classList.add('frameset-tabs__heading--active');
                        } else {
                            otherHeading.classList.remove('frameset-tabs__heading--active');
                        }
                    }
                    for (const headingMobile of this.headingMobile) {
                        const headingMobileTabId = headingMobile.getAttribute('data-tab-id');
                        if (headingMobileTabId === headingTabId) {
                            headingMobile.classList.add('frameset-tabs__heading-mobile--active');
                        } else {
                            headingMobile.classList.remove('frameset-tabs__heading-mobile--active');
                        }
                    }
                    for (const content of this.content) {
                        const contentTabId = content.getAttribute('data-tab-id');
                        if (headingTabId === contentTabId) {
                            content.classList.add('frameset-tabs__content--active');
                            content.classList.add('frameset-tabs__content--mobile-active');
                        } else {
                            content.classList.remove('frameset-tabs__content--active');
                            content.classList.remove('frameset-tabs__content--mobile-active');
                        }
                    }

                    // Scroll to heading
                    this.scrollToHeading(heading);
                });
            }
        }

        // Heading mobile clicks
        if (this.headingMobile) {
            for (const headingMobile of this.headingMobile) {
                this.$listen(headingMobile, 'click', () => {

                    // Handle active classes
                    const headingMobileTabId = headingMobile.getAttribute('data-tab-id');
                    for (const heading of this.heading) {
                        const headingTabId = heading.getAttribute('data-tab-id');
                        if (headingTabId === headingMobileTabId) {
                            heading.classList.toggle('frameset-tabs__heading--active');
                        } else {
                            heading.classList.remove('frameset-tabs__heading--active');
                        }
                    }
                    for (const otherHeadingMobile of this.headingMobile) {
                        const otherHeadingMobileTabId = otherHeadingMobile.getAttribute('data-tab-id');
                        if (otherHeadingMobileTabId === headingMobileTabId) {
                            otherHeadingMobile.classList.toggle('frameset-tabs__heading-mobile--active');
                        } else {
                            otherHeadingMobile.classList.remove('frameset-tabs__heading-mobile--active');
                        }
                    }
                    for (const content of this.content) {
                        const contentTabId = content.getAttribute('data-tab-id');
                        if (headingMobileTabId === contentTabId) {
                            content.classList.toggle('frameset-tabs__content--mobile-active');
                        } else {
                            content.classList.remove('frameset-tabs__content--mobile-active');
                        }
                    }

                    // Scroll to heading
                    this.scrollToHeading(headingMobile);
                });
            }
        }
    }

    scrollToHeading(heading: HTMLButtonElement) {
        heading.scrollIntoView(true);
    }
}
